<template>
  <div class="block-cars cars">
    <div class="container">
      <h2 class="cars__title title">Автомобили Geely</h2>

      <ul class="cars__list">
        <li
          v-for="car in cars"
          :key="car.key"
          class="cars__car car"
          :id="car.key"
        >
          <div class="car__container">
            <div class="car__content">
              <div class="car__top-line">
                <div>
                  <h2 class="car__name">
                    <span>{{ car.fresh ? "New" : "" }}</span>
                    {{ car.name }}
                  </h2>

                  <h4 class="car__advantage advantage">
                    Подарок на сумму до <span>100 000 ₽*</span>
                    <div class="car__icon-wrapper">
                      <img src="../images/icons/question.png" alt="" />
                    </div>
                  </h4>
                </div>

                <ul
                  class="car__features"
                  :class="{
                    'car__features--single': car.features.length === 1,
                    'car__features--one-gift': car.features.length > 1,
                  }"
                >
                  <li
                    v-for="feature in car.features"
                    :key="feature.text"
                    class="car__feature feature"
                    :class="{ 'feature--only-one': car.features.length == 1 }"
                  >
                    <a
                      class="car__feature-link"
                      @click.prevent="
                        getCall({
                          type: 'sale',
                          form: 'cars',
                          text: feature.text,
                        })
                      "
                    >
                      <div class="car__feature-wrapper">
                        <img :src="feature.icon" alt="" />
                      </div>
                      <p v-html="feature.text"></p>
                    </a>
                  </li>
                </ul>

                <ul class="car__features-mobile">
                  <li
                    class="car__feature feature"
                    v-if="car.features.length === 1"
                  >
                    <a
                      class="car__feature-link"
                      @click.prevent="
                        getCall({
                          type: 'sale',
                          form: 'cars',
                          text: car.features[0].text,
                        })
                      "
                    >
                      <div class="car__feature-wrapper">
                        <img :src="car.features[0].icon" alt="" />
                      </div>
                      <p v-if="car.count" v-html="car.features[0].text"></p>
                      <span v-else>Уже в продаже!</span>
                    </a>
                  </li>

                  <li></li>
                  <li class="car__feature feature">
                    <a
                      @click.prevent="
                        getCall({
                          type: 'sale',
                          form: 'cars',
                          text: `${car.count} а/м в наличии`,
                        })
                      "
                    >
                      <span v-if="car.count"
                        >{{ car.count | finance }} а/м в наличии</span
                      >
                      <span v-else>Уже в продаже!</span>
                    </a>
                  </li>
                </ul>
              </div>

              <div class="car__swiper swiper-container">
                <ul class="car__slider swiper-wrapper">
                  <li class="car__slide slide swiper-slide">
                    <a
                      @click.prevent="
                        getCall({
                          type: 'sale',
                          form: 'cars',
                          text: `Узнать подробнее об ${car.name}`,
                        })
                      "
                      class="slide__link"
                    >
                      <img
                        class="slide__img"
                        :src="carImage(car.key, car.activeColor)"
                        :alt="car.name"
                      />
                    </a>
                  </li>
                </ul>

                <!-- <div class="cars__controls">
                  <div class="arrow arrow-left">
                    <img
                      src="../images/icons/arrow-left.svg"
                      alt="Посмотреть следующие картинки"
                    />
                  </div>
                  <div class="arrow arrow-right">
                    <img
                      src="../images/icons/arrow-right.svg"
                      alt="Посмотреть предыдущие картинки"
                    />
                  </div>
                </div>
                <div class="swiper-pagination"></div> -->
              </div>
              <ul v-if="car.colors" class="car__colors">
                <li
                  v-for="(item, i) in car.colors"
                  :key="i"
                  class="car__color"
                  :class="{
                    'car__color--active': activeColor === item.image,
                  }"
                  :style="{ background: item.color }"
                  @click="car.activeColor = item.image"
                ></li>
              </ul>
            </div>

            <div class="car__info info">
              <h4 class="info__existence">
                <span v-if="car.count"
                  >{{ car.count | finance }} а/м в наличии</span
                >
                <span v-else>Уже в продаже!</span>
              </h4>

              <ul class="info__benefits">
                <template v-for="benefit in car.benefits">
                  <li :key="benefit.text" class="info__benefit benefit">
                    <a
                      @click.prevent="
                        getCall({
                          type: 'sale',
                          form: 'cars',
                          text: benefit.alt,
                        })
                      "
                      class="benefit__link"
                      href="#"
                    >
                      <img
                        class="benefit__image-mobile"
                        src="../images/icons/benefits/benefit.svg"
                        :alt="benefit.alt"
                      />
                      <img
                        class="benefit__image-desktop"
                        :src="benefitIcon(benefit.icon)"
                        :alt="benefit.alt"
                      />
                      <h3 class="benefit__title" v-html="benefit.text" />
                    </a>
                  </li>
                </template>
              </ul>

              <div class="info__buttons">
                <button
                  @click="
                    getCall({
                      type: 'sale',
                      form: 'cars',
                      text: 'Рассчитать кредит',
                    })
                  "
                  class="button info__button button_theme_secondary"
                >
                  Рассчитать кредит
                </button>

                <button
                  @click="
                    getCall({
                      type: 'sale',
                      form: 'cars',
                      text: 'Цена по АКЦИИ!',
                    })
                  "
                  class="button info__button button_theme_primary"
                >
                  Цена по АКЦИИ!
                </button>
              </div>
            </div>
            <div class="car__gallery swiper-container">
              <ul class="car__gallery-slider swiper-wrapper">
                <li
                  v-for="slide in car.gallery"
                  :key="slide"
                  class="car__gallery-slide slide swiper-slide"
                >
                  <!-- <a
                      @click.prevent="
                        getCall({
                          type: 'sale',
                          form: 'cars',
                          text: `Узнать подробнее об ${car.name}`,
                        })
                      "
                      class="slide__link"
                    > -->
                  <img
                    class="slide__img"
                    :src="carImageGallery(car.key, slide)"
                    :alt="car.name"
                    @click="openGallery(car, slide)"
                  />
                  <!-- </a> -->
                </li>
              </ul>
            </div>

            <div class="car__gifts" v-if="car.features.length > 1">
              <li
                v-for="feature in car.features"
                :key="feature.text"
                class="car__gift"
                @click.prevent="
                  getCall({ type: 'sale', form: 'cars', text: feature.text })
                "
              >
                <img :src="feature.icon" />
                <p v-html="feature.text"></p>
              </li>
            </div>
          </div>

          <div class="car__buttons">
            <button
              @click="
                getCall({
                  type: 'sale',
                  form: 'cars',
                  text: 'Рассчитать кредит',
                })
              "
              class="button car__button button_theme_secondary"
            >
              Рассчитать кредит
            </button>

            <button
              @click="
                getCall({
                  type: 'sale',
                  form: 'cars',
                  text: 'Цена по АКЦИИ!',
                })
              "
              class="button car__button button_theme_primary"
            >
              Цена по АКЦИИ!
            </button>
          </div>
        </li>
      </ul>
    </div>
    <transition name="fade">
      <gallery-viewer ref="viewer" />
    </transition>
  </div>
</template>

<script>
import Mixin from "../common/mixin";
import CARS from "../common/cars-info";
import Finance from "../common/finance";
import Swiper from "swiper";
import GalleryViewer from "./gallery-viewer.vue";

export default {
  name: "block-cars",
  mixins: [Mixin, Finance],
  components: { GalleryViewer },
  data() {
    return {
      swiper: null,
      cars: CARS,
      activeColor: null,
    };
  },
  computed: {
    carImage: () => (name, color) => {
      try {
        return require(`../images/cars/${name}/${color}.webp`);
      } catch {
        return require(`../images/cars/${name}/${color}.png`);
      }
    },
    carImageGallery: () => (name, num) => {
      try {
        return require(`../images/cars/${name}/gallery/${num}.webp`);
      } catch {
        try {
          return require(`../images/cars/${name}/gallery/${num}.png`);
        } catch {
          return require(`../images/cars/${name}/gallery/${num}.jpg`);
        }
      }
    },
    benefitIcon: () => (name) =>
      require(`../images/icons/benefits/${name}.svg`),
  },
  methods: {
    openGallery(car, index) {
      let gallery = [];
      for (let i = 1; i <= car.gallery; i++) {
        gallery.push(this.carImageGallery(car.key, i));
      }
      console.log(gallery);
      this.$refs.viewer.open(gallery, index - 1);
    },
    initSwiper() {
      if (this.swiper) return;
      this.swiper = new Swiper(`.car__gallery`, {
        direction: "vertical",
        slidesPerView: 5,
        spaceBetween: 10,
        // loop: true,
        // autoplay: {
        //   delay: 3000,
        // },
        // navigation: {
        //   nextEl: `.cars .arrow-right`,
        //   prevEl: `.cars .arrow-left`,
        // },
        // pagination: {
        //   el: ".cars .swiper-pagination",
        //   type: "progressbar",
        // },
        breakpoints: {
          1240: {
            slidesPerView: 5,
            spaceBetween: 10,
            direction: "horizontal",
          },
        },
      });
    },
  },
  mounted() {
    this.initSwiper();
  },
};
</script>

<style scoped lang="scss">
@import "../styles/constants.scss";

.cars {
  padding-top: calcFontSize(33, 92, 320, 1920);

  &__list {
    margin-top: calcFontSize(31, 96, 320, 1920);
    padding: 0 2px;
    display: flex;
    flex-direction: column;
    gap: calcFontSize(34, 81, 320, 1920);
  }

  .car {
    &__container {
      display: flex;
      justify-content: start;
      gap: calcFontSize(0, 82, 320, 1920);
    }

    &__colors {
      display: grid;
      grid-auto-flow: column;
      column-gap: 20px;
      justify-self: center;
      justify-content: center;
      width: 100%;
      bottom: 10px;
    }
    &__color {
      cursor: pointer;
      height: 30px;
      width: 30px;
      box-shadow: 0 1px 2px #00000030;
      border-radius: 50%;
      &--active,
      &:hover {
        border: 2px solid #fff;
        box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
      }
    }

    &__buttons {
      display: none;
    }

    &__gallery {
      position: absolute;
      right: 2.5%;
      padding-top: 5px;
      height: 70%;

      &-slider {
        width: calcFontSize(100, 200, 320, 1920);
      }

      &-slide {
        width: fit-content;
        height: fit-content;

        img {
          max-width: 100%;
          max-height: 100%;
          object-fit: cover;
        }
      }
    }

    &__content {
      display: flex;
      flex-direction: column;
      width: calcFontSize(320, 900, 320, 1920);
    }

    &__top-line {
      display: flex;
      justify-content: space-between;
    }

    &__name {
      font-weight: 500;
      font-size: calcFontSize(14, 31, 320, 1920);
      color: $dark;
      text-transform: uppercase;

      span {
        color: $red;
        font-weight: 500;
      }
    }

    &__icon-wrapper {
      position: relative;
      display: inline-block;

      &::after {
        position: absolute;
        top: -10px;
        z-index: 100;
        display: none;
        content: "При покупке автомобиля дарим каждому доп.оборудование на сумму до 100 000 ₽";
        color: #000;
        border: 1px solid #000;
        margin-left: 40px;
        padding: 5px 10px;
        width: 300px;
        font-size: 14px;
        background-color: #fff;
      }

      &:hover::after {
        display: block;
      }
    }

    &__advantage {
      margin-top: 10px;
      font-size: 20px;
      color: $red;

      span{
        display: inline-block;
      }

      img {
        position: relative;
        display: inline-block;
        width: 20px;
        margin-left: 5px;
        cursor: pointer;
      }

      .advantage {
        &__sup {
          font-family: "Inter", sans-serif;
          font-size: 0.7em;
        }
      }
    }

    &__features {
      &--one-gift {
        position: relative;

        &::after {
          color: #fff;
          content: "Подарок при покупке на выбор*";
          white-space: nowrap;
          padding: 5px 40px;
          background: linear-gradient(
            90deg,
            rgba(255, 255, 255, 0) 0%,
            rgba(0, 167, 255, 1) 35%,
            rgba(93, 96, 255, 1) 50%,
            rgba(199, 0, 255, 1) 65%,
            rgba(244, 67, 54, 0) 100%
          );
          position: absolute;
          bottom: -40px;
          right: 0;
        }
      }
    }

    &__gifts {
      display: flex;
      flex-direction: column;
      position: relative;

      &::after {
        color: #fff;
        content: "Дарим ВСЁ при покупке!*";
        white-space: nowrap;
        position: absolute;
        bottom: -40px;
        left: 50%;
        padding: 5px 40px;
        transform: translateY(-50%) translateX(-50%);
        background: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0) 0%,
          rgba(0, 167, 255, 1) 35%,
          rgba(93, 96, 255, 1) 50%,
          rgba(199, 0, 255, 1) 65%,
          rgba(244, 67, 54, 0) 100%
        );
      }
    }

    &__gift {
      font-size: 11px;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      padding: 20px;
    }

    &__features,
    &__features-mobile {
      margin-top: 5px;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: calcFontSize(10, 15, 320, 1920);

      &--single {
        grid-template-columns: 1fr;
      }

      .feature {
        font-size: calcFontSize(11, 14, 320, 1920);
      }
    }

    &__features-mobile,
    &__gifts {
      display: none;
    }

    &__feature-link {
      display: flex;
      align-items: center;
      color: #7c7c7c;
    }

    &__feature-wrapper {
      display: flex;
      justify-content: center;
      width: 30px;
      margin-right: 5px;
      flex: 0 0 30px;
    }


    .car__swiper {
      position: relative;
      width: 100%;

      .arrow {
        position: absolute;
        top: 41.2%;
        transform: translateY(-50%);
        cursor: pointer;
        z-index: 2;

        display: flex;
        align-items: center;
        justify-content: center;

        img {
          height: calcFontSize(9, 31, 320, 1920);
          width: calcFontSize(5, 15, 320, 1920);
        }

        &:hover {
          filter: brightness(0);
        }

        &-left {
          left: 0;
        }

        &-right {
          right: 0;
        }
      }

      .swiper-pagination {
        position: absolute;
        bottom: 15px;
        left: 0;
        right: 0;
        height: 1px;
        background: $gray;
        top: unset;
      }
    }

    &__existence {
      display: none;
    }

    .car__slider {
      display: flex;

      .slide {
        &__link {
          display: flex;
          justify-content: center;
          align-items: center;
          height: calcFontSize(136, 396, 320, 1920);
          width: calcFontSize(320, 817, 320, 1920);
          padding-bottom: calcFontSize(10, 0, 320, 1920);
        }

        &__img {
          height: 100%;
          width: 100%;
          object-fit: contain;
        }
      }
    }

    &__info {
      margin-top: 4px;
      display: flex;
      flex-direction: column;
      padding: calcFontSize(16, 25, 320, 1920) calcFontSize(16, 24, 320, 1920)
        calcFontSize(16, 33, 320, 1920) calcFontSize(16, 22, 320, 1920);
      border: 0.5px solid $transparent-black;
      width: calcFontSize(200, 365, 320, 1920);
      min-width: calcFontSize(200, 365, 320, 1920);
      align-self: flex-start;

      .info {
        &__existence {
          font-weight: 500;
          font-size: calcFontSize(13, 18, 320, 1920);
          color: $dark;
        }

        &__benefits {
          margin-top: 18px;

          .benefit {
            display: flex;
            flex-direction: column;
            padding: calcFontSize(10, 25, 320, 1920) 0
              calcFontSize(10, 21, 320, 1920);

            &__image {
              &-mobile {
                display: none;
              }
            }

            &:not(:last-child) {
              border-bottom: 1px solid $transparent-grey;
            }

            &__link {
              display: flex;
              align-items: center;
              gap: calcFontSize(5, 20, 320, 1920);
            }

            &__title {
              font-size: calcFontSize(12, 16, 320, 1920);
              color: $dark;
            }
          }
        }

        &__buttons {
          margin-top: calcFontSize(11, 12, 320, 1920);
          display: flex;
          flex-direction: column;
          gap: calcFontSize(9, 15, 320, 1920);
        }

        &__button {
          height: 50px;
        }
      }
    }
  }
}

@media (max-width: 1240px) {
  .cars {
    .car {
      &__container{
        justify-content: space-between;
        position: relative;
      }

      &__gallery {
        position: absolute;
        height: 150px;
        padding: 0;
        left: 0;
        right: auto;
        top: auto;
        bottom: 0;
        width: 70%;
      }
    }
  }
}

@media (max-width: 1100px) {
  .cars {
    .car {
      &__features {
        max-width: 60%;
      }
    }
  }
}

@media (max-width: 920px) {
  .cars {
    .car {
      &__gallery {
        position: absolute;
        height: 100px;
        right: auto;
        bottom: calcFontSize(870, 820, 320, 920);
        width: 95%;
        left: 2.5%;
      }

      &__container {
        flex-direction: column;
        gap: calcFontSize(26, 30, 320, 1920);
        border: 1px solid $transparent-black;
        padding: 31px 9px 28px 9px;
      }

      &__colors {
        column-gap: 10px;
        bottom: -10px;
        padding-bottom: calcFontSize(50, 150, 320, 920);
      }
      &__color {
        height: 18px;
        width: 18px;
      }

      &__advantage {
        font-size: 14px;
      }

      &__buttons {
        margin-top: 11px;
        gap: 8px;
        display: flex;
        flex-direction: column;
      }

      &__button {
        height: 50px;
      }

      &__features {
        display: none;
      }

      &__gifts {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: center;
      }

      &__gift{
        width: 30%;
      }

      &__features-mobile {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        margin-top: 20px;

        .feature {
          text-decoration: none;

          &:hover {
            text-decoration: underline;
          }
        }
      }

      &__top-line {
        padding: 0 13px;
        position: relative;
        flex-wrap: wrap;
      }

      &__content {
        width: 100%;
      }

      &__slider {
        display: flex;

        .slide {
          margin-top: 33px;
          display: flex;
          justify-content: center;
        }
      }

      &__existence {
        display: block;
      }

      &__info {
        border: none;
        width: 100%;
        padding: 0;
        margin-top: unset;

        .info {
          &__existence {
            display: none;
          }

          &__benefits {
            display: flex;
            gap: 18px;
            flex-direction: column-reverse;
            margin-top: unset;
            padding: 0 12px;

            .benefit {
              margin-top: unset;
              padding: unset;

              &:not(:last-child) {
                border-bottom: unset;
              }

              &__image {
                &-mobile {
                  display: block;
                }
                &-desktop {
                  display: none;
                }
              }
            }
          }

          &__buttons {
            display: none;
          }
        }
      }

      .car {
        &__swiper {
          .arrow {
            background: $transparent-white;
            width: calcFontSize(19, 30, 320, 920);
            height: calcFontSize(19, 30, 320, 920);
            border-radius: 50%;
            top: 53%;

            img {
              height: 100%;
            }
          }

          .swiper-pagination {
            bottom: 0;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
@import "../styles/constants.scss";

.cars {
  .benefit {
    &__title {
      .price,
      .rubles {
        font-size: 22px;
      }

      .price {
        font-weight: bold;
      }
    }
  }

  .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
    height: 3px;
    background: $blue;
    top: -1px;
  }
}

@media (max-width: 920px) {
  .cars {
    .benefit {
      &__title {
        .price,
        .rubles {
          font-size: inherit;
        }

        .price {
          font-weight: bold;
        }
      }
    }

    .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
      background: $black;
    }
  }
}
</style>
